import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { markHandoffComplete, sanitizeMemoriesReturnUrl } from '../utils/memoriesAuthBridge';

/**
 * Memories host: accept the traveler JWT from the main-app bridge hash and
 * continue to the requested album/list URL. Same account — shared session copy.
 */
const MemoriesAuthHandoff = () => {
  const [error, setError] = useState('');

  useEffect(() => {
    try {
      const hash = typeof window !== 'undefined' ? window.location.hash.replace(/^#/, '') : '';
      const params = new URLSearchParams(hash);
      const token = params.get('token');
      const next = sanitizeMemoriesReturnUrl(params.get('next'), '/');
      if (!token) {
        setError('Missing session. Please sign in again.');
        return;
      }
      localStorage.setItem('token', token);
      markHandoffComplete();
      // Full navigation so AuthContext re-reads the token on load.
      window.location.replace(next);
    } catch (err) {
      setError(err.message || 'Could not continue to Memories');
    }
  }, []);

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="50vh"
      gap={2}
      px={2}
    >
      <CircularProgress size={36} />
      <Typography variant="body2" color="text.secondary" textAlign="center">
        {error || 'Signing you into Memories…'}
      </Typography>
    </Box>
  );
};

export default MemoriesAuthHandoff;
